import React from 'react';
import classNames from 'classnames';

import css from './IconMicrowave.module.css';

/**
 * IconMicrowave icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconMicrowave = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M0 5.14275C0 4.19599 0.767511 3.42847 1.71429 3.42847H22.2857C23.2325 3.42847 24 4.19599 24 5.14275V18.857C24 19.8038 23.2325 20.5713 22.2857 20.5713H1.71429C0.767511 20.5713 0 19.8038 0 18.857V5.14275ZM4.36503 7.00707H15.3492C15.9007 7.00707 16.3477 7.45416 16.3477 8.00564V15.9941C16.3477 16.5456 15.9007 16.9927 15.3492 16.9927H4.36503C3.81355 16.9927 3.36648 16.5456 3.36648 15.9941V8.00564C3.36648 7.45416 3.81355 7.00707 4.36503 7.00707ZM18.3293 8.29059C18.3293 7.69885 18.809 7.21916 19.4007 7.21916H21.1946C21.7863 7.21916 22.266 7.69885 22.266 8.29059C22.266 8.88233 21.7863 9.36202 21.1946 9.36202H19.4007C18.809 9.36202 18.3293 8.88233 18.3293 8.29059ZM19.4007 10.9285C18.809 10.9285 18.3293 11.4082 18.3293 11.9999C18.3293 12.5916 18.809 13.0713 19.4007 13.0713H21.1946C21.7863 13.0713 22.266 12.5916 22.266 11.9999C22.266 11.4082 21.7863 10.9285 21.1946 10.9285H19.4007Z" fill="#262338"/>
</svg>

  );
};

export default IconMicrowave;
